import {styled} from '@mui/material'
import EditableInput from 'components/Control/EditableInput'
import {FormErrorMessage} from 'components/Control/Form'
import FormImageUpload from 'components/Control/Form/FormImageUpload'
import FormSelect from 'components/Control/Form/FormSelect'
import {familyStatuses, genderKod} from 'constants/users'
import {useFormContext} from 'react-hook-form'
import {useDeviceDetect} from 'services/hooks'
import {formatKeyFunctionsByType} from 'services/utils/tables'
import {useI18n} from 'store/Store'

const PersonalDetails = ({editMode, errorMessage}) => {
    const {i18n} = useI18n()
    const {isMobile} = useDeviceDetect()

    const formContext = useFormContext()
    console.log('form context', formContext)
    const {
        control: formControl,
        formState: {errors: formErrors},
    } = formContext

    return (
        <Container isMobile={isMobile}>
            <Column>
                <EditableInput
                    editMode={editMode}
                    name="ClientFirstName"
                    label={i18n.t('clients.ClientFirstName')}
                    formControl={formControl}
                    formErrors={formErrors}
                />
                <EditableInput
                    editMode={editMode}
                    name="ClientLastName"
                    label={i18n.t('clients.ClientLastName')}
                    formControl={formControl}
                    formErrors={formErrors}
                />
                {!editMode && (
                    <EditableInput
                        readOnly={true}
                        editMode={false}
                        name="CleanClientPhone"
                        label={i18n.t('clients.ClientPhone')}
                        formControl={formControl}
                        formErrors={formErrors}
                    />
                )}
                <EditableInput
                    editMode={editMode}
                    name="ClientEmail"
                    label={i18n.t('clients.ClientEmail')}
                    formControl={formControl}
                    formErrors={formErrors}
                />
                {!editMode && (
                    <EditableInput
                        readOnly={true}
                        editMode={false}
                        name="CleanClientId"
                        label={i18n.t('clients.ClientId')}
                        formControl={formControl}
                        formErrors={formErrors}
                    />
                )}
                <FormImageUpload
                    editMode={editMode}
                    name="ClientIdPhoto"
                    label={i18n.t('clients.ClientIdPhoto')}
                    control={formControl}
                    formErrors={formErrors}
                />
            </Column>
            <Column>
                <FormSelect
                    editMode={editMode}
                    itemName="users"
                    name="GenderKod"
                    label={i18n.t('clients.GenderKod')}
                    control={formControl}
                    formErrors={formErrors}
                    options={Object.keys(genderKod)}
                    format={(value) =>
                        formatKeyFunctionsByType().gender(value, i18n)
                    }
                />
                <FormSelect
                    editMode={editMode}
                    itemName="users"
                    name="FamilyStatus"
                    label={i18n.t('clients.FamilyStatus')}
                    control={formControl}
                    formErrors={formErrors}
                    options={Object.keys(familyStatuses)}
                    format={(value) =>
                        formatKeyFunctionsByType().familyStatus(value, i18n)
                    }
                />
                <EditableInput
                    editMode={editMode}
                    name="ChildrenNumber"
                    label={i18n.t('clients.ChildrenNumber')}
                    formControl={formControl}
                    formErrors={formErrors}
                />

                <EditableInput
                    editMode={editMode}
                    name="WorkName"
                    label={i18n.t('clients.WorkName')}
                    formControl={formControl}
                    formErrors={formErrors}
                />

                <EditableInput
                    editMode={editMode}
                    name="Profession"
                    label={i18n.t('clients.Profession')}
                    formControl={formControl}
                    formErrors={formErrors}
                />
            </Column>
            {errorMessage && (
                <FormErrorMessage>{errorMessage}</FormErrorMessage>
            )}
        </Container>
    )
}

export default PersonalDetails

const Container = styled('div')`
    display: flex;
    flex-direction: ${({isMobile}) => (isMobile ? 'column' : 'row')};
    padding-block: 48px;
    gap: ${({isMobile}) => (isMobile ? 0 : 100)}px;
    height: 100%;
`

const Column = styled('div')`
    display: flex;
    flex-direction: column;
    flex: 1;
    /* justify-content: space-between; */
`
